import React, { useEffect, useState } from "react";
import GenericInvoiceTable from "../tables/GenericInvoiceTable";
import useApi from "../../hooks/useApi";
import { productiontableConfig } from "../config/ProductionTableConfig";

const ProductionTable = ({
  items,
  onItemsChange,
  setShowSidebar,
  // setItemInfo,
  setCurrentLocation,
  extraFields = [],
  purchaseData,
  initialRowUnitOptions,
  isOtherCostEnabled,
  setIsOtherCostEnabled,
  otherCosts = [],
  setOtherCosts,
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT_NO,
  hideAddButton = false,
  documentType,
  setFocusedProductCode,
  currentStockInhand,
}) => {
  const { request, loading } = useApi();
  const [salesmanList, setSalesmanList] = useState([]);
  const fetchSalesmanList = async () => {
    const url = `${BASE_URL}/api/MasterCount/${COMPANY_CODE}/SALESPERSONLIST/-/${DEPARTMENT_NO}`;
    try {
      const response = await request({
        url: url,
        method: "GET",
        timeout: 10000,
      });
      console.log("Response", response);

      const mappedSalesmen = (response || []).map((s) => ({
        label: s.NAME,
        value: s.EMP_ID,
      }));

      setSalesmanList(mappedSalesmen);
    } catch (err) {
      console.error("Error loading data:", err);
      setSalesmanList([]);
    }
  };

  useEffect(() => {
    fetchSalesmanList();
  }, []);
  // Hide cost columns if useraccess contains AC, SW, or ST
  let userAccess = "";
  try {
    const userObj = JSON.parse(localStorage.getItem("currentUser"));
    userAccess = userObj?.[0]?.useraccess || "";
  } catch (e) { }

  const shouldHideCost = ["-AC", "-SW", "-ST"].some((code) =>
    userAccess.includes(code),
  );

  // Filter columns if needed (keep columnFieldMap intact for data operations)
  let filteredConfig = productiontableConfig;
  if (shouldHideCost) {
    const filteredOrder = productiontableConfig.defaultColumnsOrder.filter(
      (col) => !["Unit Cost", "Amount", "Total"].includes(col),
    );
    filteredConfig = {
      ...productiontableConfig,
      defaultColumnsOrder: filteredOrder,
    };
  }

  return (
    <GenericInvoiceTable
      items={items}
      onItemsChange={onItemsChange}
      setShowSidebar={setShowSidebar}
      // setItemInfo={setItemInfo}
      setCurrentLocation={setCurrentLocation}
      extraFields={extraFields}
      documentData={purchaseData}
      config={filteredConfig}
      initialRowUnitOptions={initialRowUnitOptions}
      showOtherCostButton={false}
      onShowOtherCost={() => setIsOtherCostEnabled?.((v) => !v)}
      isOtherCostVisible={!!isOtherCostEnabled}
      otherCosts={otherCosts}
      setOtherCosts={setOtherCosts}
      salesmanOptions={salesmanList}
      hideAddButton={hideAddButton}
      documentType={documentType}
      setFocusedProductCode={setFocusedProductCode}
      currentStockInhand={currentStockInhand}
      disabledFields={["location"]}
    // disabledFields={mode === 'edit' ? [] : ["location"]}

    />
  );
};

export default ProductionTable;
